import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatProgressBar} from '@angular/material/progress-bar';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UrlService} from '../../../shared/services/url.service';
import {Company} from '../../../shared/models/company.model';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from '../../../shared/services/storage.service';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {CurrentUser} from '../../../shared/models/current-user.model';
import {PopupWindowsService} from '../../../shared/services/popup-windows.service';

@Component({
    selector: 'app-company-signup',
    templateUrl: './company-signup.component.html',
    styleUrls: ['./company-signup.component.css']
})
export class CompanySignupComponent implements OnInit {
    @ViewChild(MatProgressBar) progressBar: MatProgressBar;
    @ViewChild(MatButton) submitButton: MatButton;

    signupForm: FormGroup = this.fb.group({
        name: ['', [Validators.required,
                    Validators.minLength(5),
                    Validators.pattern(new RegExp('^[a-z0-9]*$'))]],
        agreed: [false, Validators.requiredTrue],
    });
    public nameErrMsg: string;
    baseDomain: string;
    currentUser$: Observable<CurrentUser>;

    constructor(
        public translate: TranslateService,
        private router: Router,
        private fb: FormBuilder,
        private urlService: UrlService,
        private storageService: StorageService,
        private store: Store,
        private popupWindowsService: PopupWindowsService
    ) {
        this.currentUser$ = this.store.select(state => state.currentUser.currentUser);
    }

    ngOnInit() {
    }

    signup() {
        const signupData = this.signupForm.value;

        this.submitButton.disabled = true;
        this.progressBar.mode = 'indeterminate';
        this.urlService.signup(signupData.name).subscribe(
            (company: Company) => {
                this.urlService.redirectToUserSignup(company.domains[0].domain, this.storageService.currLang);
            },
            err => {
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';
                if (err.error.schema_name) {
                    this.nameErrMsg = 'Company with this name already exists';
                    this.signupForm.markAsPristine();
                } else {
                  this.popupWindowsService.openErrorDialogWindow({message: err.error.detail});
                }
            }
        );
    }
}
